module.exports = __webpack_public_path__ + "img/image16.1f4aafb5.png";